import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';

import 'selectize';
import '../../../../frontend/lib/widgets/tags/selectize-bootstrap4.scss';
import '../../../../frontend/lib/widgets/tags/tags.scss';
import { each, isEmpty } from 'lodash-es';

const SelectizeWrapper = (
  {
    options,
    onChange,
    loadOptions,
    selectExtraProps = {}
  }
) => {
  const selectRef = useRef(null);
  const selectizeRef = useRef(null);

  useEffect(() => {
    const $select = $(selectRef.current);
    const selectedItem = (!isEmpty(selectExtraProps) && selectExtraProps['defaultValue']) ? selectExtraProps['defaultValue'] : '';

    const selectizeOptions = {
      valueField: 'value',
      labelField: 'label',
      searchField: 'label',
      options: options || [],
      onChange: (value) => {
        const option = selectizeRef.current.options[value];
        onChange(option);
      },
    };

    if (loadOptions) {
      selectizeOptions.load = async (query, callback) => {
        const response = await loadOptions(query);
        selectizeRef.current.clearOptions();
        callback(response.options);
      };
    }

    $select.selectize(selectizeOptions);
    selectizeRef.current = $select[0].selectize;

    if (selectizeRef.current && !isEmpty(selectedItem)) {
      const selectedOption = options.find(opt => opt.value == selectedItem);

      if (selectedOption) $('div.selectize-input input').val(selectedOption.label);
    }

    return () => {
      if (selectizeRef.current)
        selectizeRef.current.destroy();
    };
  }, [options, onChange, loadOptions, selectExtraProps['defaultValue']]);

  return <select ref={selectRef} {...selectExtraProps} />;
};

SelectizeWrapper.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func,
  selectExtraProps: PropTypes.object,
};

export default SelectizeWrapper;
